<mat-card>
  <mat-card-header>
    <mat-card-title>{{pageType | capitalize }} Course</mat-card-title>
  </mat-card-header>
  <form class="course-form">
    <mat-card-content>
      <mat-card-subtitle>Details</mat-card-subtitle>

      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Title</mat-label>
        <input matInput [formControl]="courseForm.get('title')" required>
        <mat-error *ngIf="formService.controlHasError( courseForm.get('title'), 'required')">This field is required
        </mat-error>
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Description</mat-label>
        <textarea matInput [formControl]="courseForm.get('description')" rows="5"></textarea>
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Country</mat-label>
        <mat-select [formControl]="courseForm.get('country')" required>
          <mat-option *ngFor="let country of countries" [value]="country">
            {{country.toUpperCase()}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Subjects</mat-label>
        <mat-select [formControl]="courseForm.get('subjects')" multiple>
          <mat-option *ngFor="let subject of subjects" [value]="subject.id.toString()">
            {{subject.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-card-content>

    <!--Lessons-->
    <mat-card class="lessons-card" *ngIf="pageType==='edit' && course">
      <div class="lessons-heading">
        <h2 class="lessons-heading-title">Lessons</h2>
        <button mat-button color="primary" [routerLink]="['/courses/' + course.id + '/lessons/create/']">
          Add Lesson
        </button>
      </div>

      <mat-card-content>
        <mat-accordion>
          <!--Lesson Start -->
          <mat-expansion-panel *ngFor="let lesson of course.lessons" [expanded]="false" draggable="true"
                              (dragend)="dragEnd(lesson.id, course.lessons)"
                              (dragstart)="sortListService.dragStart($event, lesson.id)"
                              (dragenter)="sortListService.dragEnter($event, lesson.id)">
            <mat-expansion-panel-header class="draggable">
              <mat-panel-title>
                <mat-icon class="draggable">drag_handle</mat-icon>
                <a routerLink="/courses/{{course.id}}/lessons/{{lesson.id}}/edit">{{lesson.title}}</a>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p>{{lesson.description}}</p>
          </mat-expansion-panel>
          <!--Lesson End -->
        </mat-accordion>
      </mat-card-content>
    </mat-card>
    <!--End Lessons-->

    <mat-card-actions class="course-actions" align="end">
      <button *ngIf="pageType === 'edit' && courseStatus" mat-raised-button color="primary" [disabled]="!courseForm.valid || isSubmitting" (click)="toggleActive(course)">{{courseStatus}}</button>
      <button mat-raised-button color="primary" [disabled]="!courseForm.valid || isSubmitting" (click)="submitForm()">
        {{buttonName}}
      </button>
    </mat-card-actions>
  </form>
</mat-card>
